import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import md5 from 'blueimp-md5';

// Calculate season week dynamically based on May 1, 2025 = week 3
function getCurrentWeekNumber(now = new Date()) {
  const base = new Date(2025, 4, 1);
  const msPerWeek = 7 * 24 * 60 * 60 * 1000;
  const delta = now.getTime() - base.getTime();
  const weeksSince = delta >= 0 ? Math.floor(delta / msPerWeek) : 0;
  return 3 + weeksSince;
}
// Avatar component (Gravatar → Clearbit → Dicebear)
const Avatar = ({ email, name, size = 120 }) => {
  //const hash = md5(email.trim().toLowerCase());
  
  const flname = name.split(" ")
  const initals = flname[0].charAt(0)+""+flname[1].charAt(0)

  const urls = [
    //`https://www.gravatar.com/avatar/${hash}?s=${size}&d=404`,
    //`https://avatar.clearbit.com/${encodeURIComponent(email || "abcd")}?size=${size}`,
    `https://api.dicebear.com/9.x/initials/svg?seed=${initals}&backgroundColor=b6e3f4,c0aede,d1d4f9&size=${size}`
  ];
  const [src, setSrc] = useState(urls[0]);

  return (
    <img
      src={src}
      alt={name}
      width={size}
      height={size}
      className="rounded-circle mr-4 ml-4"
      onError={() => {
        const idx = urls.indexOf(src);
        if (idx < urls.length - 1) setSrc(urls[idx + 1]);
      }}
    />
  );
};

const MNGLProfile = () => {
  const params = new URLSearchParams(window.location.search);
  // Normalize + and %20 to spaces, then decode
  const raw = params.get('player') || '';
  const playerName = decodeURIComponent(raw.replace(/\+/g, ' '));
  const urlParams = useParams();
  const playerId = urlParams.id || params.get('id') || '';
  const playerPhone = params.get('phone')

  const [teeTimes, setTeeTimes] = useState({});
  const [webResults, setWebResults] = useState({});
  const [playerSData, setPlayerSData] = useState(null);
  const [scores, setScores] = useState([]);
  const [phone, setPhone] = useState("");
  const [error, setError] = useState('');
  const thisWeek = getCurrentWeekNumber();

  // Fetch tee times and dynamic quotas
  useEffect(() => {
    fetch('https://api.threes.day/mngl/tees')
      .then(res => res.json())
      .then(data => {
        if (data.teeTimes && data.teeTimes.length > 0) {
          setTeeTimes(data.teeTimes[0]);
        }
      })
      .catch(console.error);

    fetch('https://api.threes.day/mngl/web-results')
      .then(res => res.json())
      .then(data => {
        const map = {};
        data.forEach(item => {
          map[item.name] = item;
        });
        setWebResults(map);
      })
      .catch(console.error);

      if(playerPhone){
        fetch('https://api.threes.day/player/phone/'+playerPhone)
        .then(res => res.json())
        .then(data => {
          console.log('player', data)
          setPlayerSData(data)
          const scores = data.scores.sort((r1,r2)=>r2.week-r1.week)
          console.log('scores', scores)
          setScores(scores)
        })
        .catch(()=>{
          setError('Error with Server')
          console.error
      });
      } else
      if(playerId){
        fetch('https://api.threes.day/player/'+playerId)
        .then(res => res.json())
        .then(data => {
          console.log('player', data)
          setPlayerSData(data)
          const scores = data.scores.sort((r1,r2)=>r2.week-r1.week)
          console.log('scores', scores)
          setScores(scores)
        })
        .catch(()=>{
          setError('Error with Server')
          console.error
      });
      } else {
        if(localStorage.phone){
          window.location.href = '/b/profile?phone='+localStorage.phone
          return
        }
        setError('nophone')
      }
  }, []);

  const enterPhone = (e) => {
    e.preventDefault(); 
    localStorage.phone = phone;
    window.location.href = '/b/profile?phone='+phone
  };

  if(error=='nophone') {
    return <div className="container py-5">
      <div className="mb-4 text-center">
        <form onSubmit={enterPhone}>
        <h2>Sign In</h2>
        <h3>Enter your phone number to get started</h3>
        <input
          type="tel" 
          id="phone"
          className="w-100"
          value={phone}
          onChange={e => setPhone(e.target.value)}
          placeholder="Enter phone number"
        /><br />
        <button 
          type="submit" 
          className="w-100 bg-success text-white mt-1 rounded"
        >
          Sign In
        </button>
        </form>
      </div>
      </div>
  } else
  if (error) {
    return <div className="container py-5">
    <div className="mb-4 text-center">
      <h2>Not Found</h2>
      <h3>Your phone wasn't found. Please contact your league admin for assistance.</h3>
      <hr />
      <p>If you'd like to add your league, please contact: golf@mngl.org</p>
      <hr />
    </div>
    </div>;
  }
  if (!playerSData) {
    return <div className="container py-5">
    <div className="mb-4 text-center">
      <h2>Loading Player</h2>
      <h3>Don't forget to clean your balls.</h3>
      </div>
      </div>;
  }

  function dayOfTheWeek(play_date){
    var days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
    var dotw = (new Date(play_date)).getDay()
    return days[dotw]
  }



  return (
    <div className="container">
      <h1 className="mb-4 text-center">{playerSData.formattedName}</h1>
      <div className="d-flex align-items-center">
        {(playerSData)?
        <Avatar email={playerSData.email} name={playerSData.formattedName} size={120} />:null}
        <div className="ms-4">
          <p className="mb-0"><strong>Email:</strong> <a className="text-secondary"  href={`mailto:${playerSData.email}`}>{playerSData.email}</a></p>
          <p className="mb-0"><strong>Phone:</strong> <a className="text-secondary" href={`sms:${playerSData.phone}`}>{playerSData.phone}</a></p>
          <p className="mb-0"><strong>Starting Quota:</strong> {playerSData.quota}</p>
          <p className="mb-0"><strong>Current Quota:</strong> {playerSData.calculatedQuota}</p>
          <p className="mb-0"><strong>Last Score:</strong> {(playerSData.scores?.sort((s1,s2)=>s2.week-s1.week)[0])?.shots}</p>
          <p className="mb-0"><strong>Average Score:</strong> {parseInt(playerSData?.avgScore)}</p>
          {(playerSData.scores?.length>0)?
          <p className="mb-0"><strong>Wins:</strong> {playerSData.wins}/{playerSData.scores.length} - {parseInt(100*playerSData.wins/playerSData.scores.length)}%</p>:null}
        </div>

      </div>
      <div className="mt-4 align-items-center text-center">
        <strong>Preferred playing time:</strong> {playerSData.preferences || 'Any time'}
      </div>
      <div className="mt-4">
        <hr/>
        <div className="align-items-center text-center mb-1">
          <h2 className="m-0">Week {playerSData.current_week} Match</h2>
          <strong className="mt-0 fs-6">{dayOfTheWeek(playerSData.play_date)} {new Date(playerSData.play_date).getMonth()+1}/{new Date(playerSData.play_date).getDate()+1} {playerSData.tee_time?.time}</strong>
        </div>
        <div className="d-flex">
          {(Object.values(playerSData?.weather)?.length>0)?
          <div className="ms-4  justify-content-end rounded mr-3 small p-2 text-white bg-primary">
            <h3 className="m-0">Weather</h3>
            <strong className="small m-0 bold strong bg-white text-dark badge align-center w-100">Forecast for {new Date(playerSData.play_date).getMonth()+1}/{new Date(playerSData.play_date).getDate()+1}</strong>
            <p className="mb-0 small">High: {playerSData.weather.high}&deg; F</p>
            <p className="mb-0 small">Wind: {playerSData.weather.wind} MPH</p>
            <p className="mb-0 small">Gusts: {playerSData.weather.gusts} MPH</p>
            <p className="mb-0 small">Rain: {playerSData.weather.rainChance}%</p>
          </div>:null}
          {(Object.values(playerSData?.current_opp)?.length>0)?
          <div className="ms-4 bg-light rounded p-2 w-100">
            <h3 className="m-0 fs-2"><small>vs</small> {playerSData.current_opp.displayName}</h3>
            <p className="mb-0">Quota: {playerSData.current_opp.calculatedQuota}</p>
            <p className="mb-0 small">You ({(playerSData.calculatedQuota-playerSData.current_opp.calculatedQuota<0)?'get':'give'}): {Math.abs((playerSData.calculatedQuota-playerSData.current_opp.calculatedQuota).toFixed(2))} strokes</p>
            <p className="mb-0">Wins: {(playerSData.current_opp.rounds)?(playerSData.current_opp.wins/playerSData.current_opp.rounds*100).toFixed(0):0}%</p>
            <p className="mb-0">Available: {playerSData.current_opp.preferences || "Any tee time"}</p>
            {(!playerSData.tee_time || Object.keys(playerSData.tee_time).length == 0)?
              <p className="mb-0 small">Open Tee Times:<br/>{playerSData.available_tee_times.map((time)=><a href={`http://www.mngl.org/weekly-matches`} target="native-sheet"><span className="badge bg-success mr-1 text-white">{time}</span></a>) || "Any tee time"}</p>
              :
              <p className="mb-0 small">Booked Tee Time: <span className="badge bg-success mr-1 text-white">{playerSData.tee_time.time}</span></p>
            }
            
          </div>:null}
          
        </div>
        <a href={`sms://${playerSData.current_opp.phone.replaceAll("(", "").replaceAll(")", "").replaceAll("-", "").replaceAll(" ", "")}`}>
          <span className="badge bg-success text-white w-100 p-2 mt-1">Text {playerSData.current_opp.displayName}</span>
        </a>
      </div>
      <div className="mt-4">
        <hr/>
        <div className="align-items-center text-center mb-1">
          <h2 className="m-0">Week {parseInt(playerSData.current_week)+1} Preview</h2>
          {(Object.values(playerSData?.next_opp)?.length>0)?
          <div className="ms-4 bg-light rounded p-2 w-100">
            <h3 className="m-0 fs-2"><small>vs</small> {playerSData.next_opp.displayName}</h3>
            <div className="text-left">
              <p className="mb-0">Quota: {playerSData.next_opp.calculatedQuota}</p>
              <p className="mb-0 small">You ({(playerSData.calculatedQuota-playerSData.next_opp.calculatedQuota<0)?'get':'give'}): {Math.abs((playerSData.calculatedQuota-playerSData.next_opp.calculatedQuota).toFixed(2))} strokes</p>
              <p className="mb-0">Wins: {(playerSData.next_opp.rounds)?(playerSData.next_opp.wins/playerSData.next_opp.rounds*100).toFixed(0):0}%</p>
              <p className="mb-0">Available: {playerSData.next_opp.preferences || "Any tee time"}</p>
            </div>
          </div>:null}
        </div>
        <a href={`sms://${playerSData.next_opp.phone.replaceAll("(", "").replaceAll(")", "").replaceAll("-", "").replaceAll(" ", "")}`}>
          <span className="badge bg-success text-white w-100 p-2 mt-1">Text {playerSData.next_opp.displayName}</span>
        </a>
      </div>
      
      {(scores)?
      <div className="mt-4">
        <hr/>
        <div className="align-items-center text-center">
        <h2>Rounds Recap</h2> 
        </div>
        <table style={{width:"100%"}}>
          <thead>
            <tr>
              <th>Week</th>
              <th>Score</th>
              <th>Quota</th>
              <th>Win/Loss</th>
              <th>Points</th>
            </tr>
          </thead>
          <tbody>
          {scores.map(round=>(
            <tr>
              <td>{round.week}</td>
              <td>{round.shots}</td>
              <td>{round.quota}</td>
              <td>{round.status?.toUpperCase()}</td>
              <td>{round.points}</td>
            </tr>
          ))}
        </tbody>
        </table>
      </div>
      :null}

    </div>
  );
};

export default MNGLProfile;
